module.exports = __webpack_public_path__ + "img/pro_feature_route_planning.c9e9f62.png";